@if (status() === "has-incident") {
  <mat-icon class="text-danger" aria-hidden="true"> visibility </mat-icon>
} @else if (status() === "no-incident") {
  <mat-icon aria-hidden="true"> visibility_off </mat-icon>
}
